module.exports = "<mat-slide-toggle>Slide me!</mat-slide-toggle>"